import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';

import { mapState, mapActions } from 'vuex';
import InputColor from '@ps/views/workbench/animation/form-components/input-color';
import { getHexColor, transformColorFormat } from '@ps/utils/game';
import { EventBus, Event } from '@ps/utils/event-bus';

export default {
  name: 'animation-color',
  components: { InputColor: InputColor },
  props: {
    config: {
      type: Object
    },
    formValue: {
      type: Object
    }
  },
  data: function data() {
    return {
      colorValue: {
        // eslint-disable-next-line no-undefined
        startColor: undefined,
        // eslint-disable-next-line no-undefined
        endColor: undefined
      },
      formConfig: {
        inline: true,
        labelPosition: 'left',
        labelWidth: '30px',
        size: 'mini'
      }
    };
  },

  computed: _extends({}, mapState({
    activeNode: function activeNode(state) {
      return state.workspace.game.activeNode;
    },
    qc: function qc(state) {
      return state.workspace.game.data;
    }
  }), {
    colorLabel: function colorLabel() {
      return this.config.prop === 'to' ? this.$t('workbench.animation.animationColor.colorLabel.to') : this.$t('workbench.animation.animationColor.colorLabel.from');
    },
    colorProp: function colorProp() {
      return this.config.prop === 'to' ? 'endColor' : 'startColor';
    },
    colorFormItemList: function colorFormItemList() {
      return [{
        prop: this.config.prop === 'to' ? 'endColor' : 'startColor',
        type: 'color-picker',
        label: this.config.prop === 'to' ? this.$t('workbench.animation.animationColor.colorLabel.from') : this.$t('workbench.animation.animationColor.colorLabel.to'),
        labelWidth: '60px',
        width: '50%',
        params: {
          'show-alpha': false
        }
      }];
    }
  }),
  methods: _extends({}, mapActions({
    setAnimation: 'workspace/game/setAnimation'
  }), {
    handleChange: function handleChange(value) {
      this.setAnimation({
        animations: _defineProperty({
          uuid: this.formValue.uuid
        }, this.config.prop, new this.qc.Color(value)),
        node: this.activeNode
      });
    },
    initColor: function initColor() {
      this.colorValue[this.colorProp] = getHexColor(transformColorFormat(this.formValue[this.config.prop]));
    }
  }),

  mounted: function mounted() {
    var _this = this;

    this.initColor();
    EventBus.$on(Event.ANIMATION_UPDATE, function () {
      setTimeout(function () {
        _this.initColor();
      }, 200);
    });
  }
};